import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";
import { CreditApplicationFormModel } from "@tCooneyBrothers/ApiModels";

const creditApplicationUrl = "api/v2/emailnew";

export async function getCreditApplicationForm() {
    try {
        const fieldCollection = await get<CreditApplicationFormModel[]>(`${creditApplicationUrl}`, {})
            .then(response => {
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return fieldCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addCreditApplicationFields(parameter: CreditApplicationFormModel) {
    return post<CreditApplicationFormModel>(creditApplicationUrl, parameter);
}
